import ErrorBg from './commonErrorBG.png'

const Images = {
    ErrorBg,
  };

export default Images;